<template>
    <div class="branded-checkbox">
        <i
            v-show="isLawnStarter"
            class="fa"
            :class="{
                'fa-lg fa-fw': isBigIcon,
                'fa-check-square': isActive || !isPlusSquare,
                'fa-plus-square': isPlusSquare && !isActive,
                'ls-color--green--color-dodge': isActive,
                'fa-square-o ls-color--gray--light': !isActive,
                ...extraClasses,
            }"
        ></i>
        <i
            v-show="isLawnLove || isHomeGnome"
            class="fa fa-fw fa-md"
            :class="{
                'fa-plus-square fa-lg': isPlusSquare && !isActive,
                'll-checkbox ls-border-all': !isPlusSquare || isActive,
                'fa-check ll-bg-green--x-light ll-border-color-primary ll-color-primary': isActive,
                ...extraClasses,
            }"
        ></i>
    </div>
</template>
<script>
import brandMixin from '@/mixins/brand.mixin';

export default {
    mixins: [brandMixin],
    props: {
        isActive: { type: Boolean },
        isBigIcon: { type: Boolean, default: false },
        isPlusSquare: { type: Boolean, default: false },
        extraClasses: {
            type: Object,
            default() {
                return {};
            },
        },
    },
};
</script>
<style lang="scss">
.branded-checkbox {
    line-height: 1;
}

.themed-lawnlove {
    .branded-checkbox {
        display: inline-flex;

        .fa-plus-square {
            font-size: 16px !important;
            margin-right: 4px !important;
        }
    }
}
</style>
